<!--page starts-->
<section class="page-wrapper">
    <div class="news-hero-section margin-top-152 cf" Style="background-image:url(assets/images/shop-open-web.jpg)">
        <div class="container">
           <div class="news-hero-detail">
           	   
           </div>
        </div>
    </div>
    <div class="membership-hero-section cf">
        <div class="container">
            <div class="membership-hero-detail cf">
                <div class="titel-box">
                    <h2 class="titel-name">2021 Blast Pass - On Sale Now!</h2>
                </div>
                <div class="membership-top-main-section-top cf">
                    <div class="membership-top-main-section faq-title active cf">
                        <a class="membership-top-main-detail faq-add">
                            <div class="membership-top-main-detail-left">
                                <p>The Running Foxes are Hungry For More!</p>
                                <h4>A New Breed of Fox is here!</h4>
                            </div>
                            <div class="membership-top-main-detail-right">
                                <a href="javascript:void(0)">BUY YOUR 2021 BLAST PASS</a>
                            </div>
                        </a>
                        <div class="membership-top-main-content faq-content">
                        <p>Leicestershire County Cricket Club can announce the introduction of the 2021 Blast Pass -  a Season Ticket option for the 2021 Vitality Blast season.</p>
                        <p>Equally, for fans interested in individual tickets, you can Register your Interest to receive priority access to these tickets before general on-sale.</p>
                        </div>
                    </div>
                    <div class="membership-top-main-section faq-title cf">
                        <a class="membership-top-main-detail faq-add">
                            <div class="membership-top-main-detail-left">
                                <p>2021 Blast Pass</p>
                                <h4>There are three Vitality Blast passes available:</h4>
                            </div>
                            <div class="membership-top-main-detail-right">
                                <a href="javascript:void(0)">BUY YOUR 2021 BLAST PASS</a>
                            </div>
                        </a>
                        <div class="membership-top-main-content faq-content">
                           <p>Leicestershire County Cricket Club can announce the introduction of the 2021 Blast Pass -  a Season Ticket option for the 2021 Vitality Blast season.</p>
                           <p>Equally, for fans interested in individual tickets, you can Register your Interest to receive priority access to these tickets before general on-sale.</p>
                        </div>
                    </div>
                    <div class="membership-top-main-section faq-title cf">
                        <a class="membership-top-main-detail faq-add">
                            <div class="membership-top-main-detail-left">
                                <p>2021 Blast Pass</p>
                                <h4>2021 Blast Passes for Members</h4>
                            </div>
                            <div class="membership-top-main-detail-right">
                                <a href="javascript:void(0)">BUY YOUR 2021 BLAST PASS</a>
                            </div>
                        </a>
                        <div class="membership-top-main-content faq-content">
                        <p>Leicestershire County Cricket Club can announce the introduction of the 2021 Blast Pass -  a Season Ticket option for the 2021 Vitality Blast season.</p>
                        <p>Equally, for fans interested in individual tickets, you can Register your Interest to receive priority access to these tickets before general on-sale.</p>
                        </div>
                    </div>
                    <div class="membership-top-main-section faq-title cf">
                        <a class="membership-top-main-detail faq-add">
                            <div class="membership-top-main-detail-left">
                                <p>2021 Blast Pass</p>
                                <h4>2021 Blast Passes for Non-Members</h4>
                            </div>
                            <div class="membership-top-main-detail-right">
                                <a href="javascript:void(0)">BUY YOUR 2021 BLAST PASS</a>
                            </div>
                        </a>
                        <div class="membership-top-main-content faq-content">
                        <p>Leicestershire County Cricket Club can announce the introduction of the 2021 Blast Pass -  a Season Ticket option for the 2021 Vitality Blast season.</p>
                        <p>Equally, for fans interested in individual tickets, you can Register your Interest to receive priority access to these tickets before general on-sale.</p>
                        </div>
                    </div>
                    <div class="membership-top-main-section faq-title cf">
                        <a class="membership-top-main-detail faq-add">
                            <div class="membership-top-main-detail-left">
                                <p>2021 Blast Pass</p>
                                <h4>Individual Match Tickets</h4>
                            </div>
                            <div class="membership-top-main-detail-right">
                                <a href="javascript:void(0)">BUY YOUR 2021 BLAST PASS</a>
                            </div>
                        </a>
                        <div class="membership-top-main-content faq-content">
                        <p>Leicestershire County Cricket Club can announce the introduction of the 2021 Blast Pass -  a Season Ticket option for the 2021 Vitality Blast season.</p>
                        <p>Equally, for fans interested in individual tickets, you can Register your Interest to receive priority access to these tickets before general on-sale.</p>
                        </div>
                    </div>
                    <div class="membership-top-main-section faq-title cf">
                        <a class="membership-top-main-detail faq-add">
                            <div class="membership-top-main-detail-left">
                                <p>2021 Membership - On Sale Now</p>
                                <h4>Car Parking</h4>
                            </div>
                            <div class="membership-top-main-detail-right">
                                <a href="javascript:void(0)">BUY YOUR 2021 BLAST PASS</a>
                            </div>
                        </a>
                        <div class="membership-top-main-content faq-content">
                        <p>Leicestershire County Cricket Club can announce the introduction of the 2021 Blast Pass -  a Season Ticket option for the 2021 Vitality Blast season.</p>
                        <p>Equally, for fans interested in individual tickets, you can Register your Interest to receive priority access to these tickets before general on-sale.</p>
                        </div>
                    </div>
                    <div class="membership-top-box membership-image">
                        <a href="javascript:void(0)"><img src="assets/images/lccc-fox-logo.svg"></a>
                    </div>
                </div>
                <!-- <div class="membership-top-detail">
                    <div class="membership-top-box">
                        <p>2021 Blast Pass</p>
                        <h4>There are three Vitality Blast passes available:</h4>
                    </div>
                    <div class="membership-top-box">
                        <p>2021 Blast Pass</p>
                        <h4>2021 Blast Passes for Members</h4>
                    </div>
                    <div class="membership-top-box">
                        <p>2021 Blast Pass</p>
                        <h4>2021 Blast Passes for Non-Members</h4>
                    </div>
                    <div class="membership-top-box">
                        <p>2021 Blast Pass</p>
                        <h4>Individual Match Tickets</h4>
                    </div>
                    <div class="membership-top-box">
                        <p>2021 Membership - On Sale Now</p>
                        <h4>Car Parking</h4>
                    </div>
                    
                    <div class="membership-top-box membership-image">
                        <a href="javascript:void(0)"><img src="assets/images/ic-logo-new.png"></a>
                    </div>
                </div> -->
                <div class="membership-ticket-refund">
                    <a href="javascript:void(0)"><img src="assets/images/download-ticket.png"></a>
                </div>
            </div>
            <div class="membership-content cf">
                <div class="titel-box">
                    <h2 class="titel-name">Everything is covered by our LCCC COVID GUARANTEE</h2>
                </div>
                <div class="membership-content-detail">
                    <p>If there is an impact to the 2021 season, Members will always have priority access to available tickets. LCCC fans can book with confidence as all memberships are covered by our LCCC COVID GUARANTEE, which provides Members with the safety of a refund option, should current disruptions continue into the 2021 season.

                    </p>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="our-partner-section cf">
        <div class="our-partner-titel">
           <div class="container">
                <div class="titel-box">
                       <h2 class="titel-name">OUR PARTNERS</h2>
                   </div>
           </div>
        </div>
        <div class="our-partner-detail cf">
            <div class="our-partner-bg"></div>
            <div class="container">
                <div class="our-partner-detail-hero">
                       <div class="our-partner-detail-hero-left">
                        <p>Official Front Of Shirt Partner</p>
                        <div class="our-partner-logo-left">
                            <img src="assets/images/img01.png">
                        </div>
                    </div>
                    <div class="our-partner-hero-right cf">
                           <ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slideparterConfig">
                            <div ngxSlickItem class="our-partner-logo slide">
                                <div class="our-partner-logo-inner">
                                       <img src="assets/images/img01.png">
                                   </div>
                            </div>
                            <div ngxSlickItem class="our-partner-logo slide">
                                <div class="our-partner-logo-inner">
                                       <img src="assets/images/img02.png">
                                </div>
                            </div>
                            <div ngxSlickItem class="our-partner-logo slide">
                                <div class="our-partner-logo-inner">
                                       <img src="assets/images/dMU.png">
                                </div>
                            </div>
                            <div ngxSlickItem class="our-partner-logo slide">
                                <div class="our-partner-logo-inner">
                                       <img src="assets/images/img05.png">
                                </div>
                            </div>
                            <div ngxSlickItem class="our-partner-logo slide">
                                <div class="our-partner-logo-inner">
                                       <img src="assets/images/img02.png">
                                </div>
                            </div>
                            <div ngxSlickItem class="our-partner-logo slide">
                                <div class="our-partner-logo-inner">
                                       <img src="assets/images/img01.png">
                                </div>
                            </div>
                        </ngx-slick-carousel>                
                    </div>
                </div>
            </div>  
        </div>
    </div> -->
</section><!-- page ends-->